import { render, staticRenderFns } from "./TargetCard.vue?vue&type=template&id=131f5b5a&scoped=true&"
import script from "./TargetCard.vue?vue&type=script&lang=js&"
export * from "./TargetCard.vue?vue&type=script&lang=js&"
import style0 from "./TargetCard.vue?vue&type=style&index=0&id=131f5b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f5b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131f5b5a')) {
      api.createRecord('131f5b5a', component.options)
    } else {
      api.reload('131f5b5a', component.options)
    }
    module.hot.accept("./TargetCard.vue?vue&type=template&id=131f5b5a&scoped=true&", function () {
      api.rerender('131f5b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/訂單流程/TargetCard.vue"
export default component.exports